import { NavLink } from "react-router";
import { useCustomersServiceObjectShowQuery } from "@/services/backend/customers/api/service-object-api";
import { Button } from "@/shared/components/ui/button";

export function ServiceObjectLink({ id }: { id?: string }) {
  const { data } = useCustomersServiceObjectShowQuery({ id: id ?? "" });

  if (!data) {
    return "";
  }

  return (
    <Button variant="link" className="h-6 px-0" asChild>
      <NavLink to={`/customers/${data.customerId}/service-objects/${data.id}`}>
        {data.name}
      </NavLink>
    </Button>
  );
}
